import React, { useState } from "react";
import PageTitle from '../../Component/Comman/PageTitle';
import Chart from 'react-apexcharts';

function Statistics() {
    const generateDayWiseTimeSeries = (baseval, count, yrange) => {
        var i = 0;
        var series = [];
        while (i < count) {
            var x = baseval;
            var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

            series.push([x, y]);
            baseval += 86400000;
            i++;
        }
        return series;
    };

    const [state] = useState({
        series: [
            {
                name: 'Own',
                data: generateDayWiseTimeSeries(new Date('11 Feb 2025 GMT').getTime(), 20, {
                    min: 10,
                    max: 60
                })
            }, {
                name: 'Reject',
                data: generateDayWiseTimeSeries(new Date('11 Feb 2025 GMT').getTime(), 20, {
                    min: 10,
                    max: 20
                })
            }
        ],
        options: {
            chart: {
                height: 300,
                type: 'area',
                stacked: true,
                toolbar: {
                    show: false,
                },
                events: {
                    selection: function (chart, e) {
                        console.log(new Date(e.xaxis.min))
                    }
                },
            },
            colors: ['#f0b90b', '#82bb47'],
            dataLabels: {
                enabled: false
            },
            fill: {
                type: 'gradient',
                gradient: {
                    opacityFrom: 0.6,
                    opacityTo: 0.8,
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                show: true,
            },
            xaxis: {
                type: 'datetime',
            },
            grid: {
                yaxis: {
                    lines: {
                        show: false,
                    }
                },
                padding: {
                    top: 20,
                    right: 0,
                    bottom: 0,
                    left: 0
                },
            },
            stroke: {
                show: true,
                curve: 'smooth',
                width: 2,
            },
        }
    });

    return (
        <>
            <div className="body-header border-bottom d-flex py-3 mb-3">
                <PageTitle pagetitle="Statistics" downloadbutton="Download" reportbutton="Generate Report" />
            </div>
            <div className="container-xxl">
                <div className="row g-3 mb-3">
                    <div className="col-md-6">
                        <div className="card d-flex flex-row flex-wrap">
                            <div className="card-body">
                                <div className="flex-fill text-truncate">
                                    <span className="text-muted small text-uppercase">Hashrate (15Min)</span>
                                    <span className="h6 mt-3 mb-1 fw-bold d-block">BTC</span>
                                    <div className="d-flex justify-content-between">
                                        <div className="price-block">
                                            <span className="fs-6 fw-bold color-price-up">148.2</span>
                                            <span className="small text-muted px-2">MH/s</span>
                                        </div>
                                        <div className="price-report">
                                            <span className="small text-success">99.4% <i className="fa fa-level-up"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="flex-fill text-truncate">
                                    <span className="text-muted small text-uppercase">Hashrate (24 H)</span>
                                    <span className="h6 mt-3 mb-1 fw-bold d-block">BTC</span>
                                    <div className="d-flex justify-content-between">
                                        <div className="price-block">
                                            <span className="fs-6 fw-bold color-price-up">108.6</span>
                                            <span className="small text-muted px-2">TH/s</span>
                                        </div>
                                        <div className="price-report">
                                            <span className="small text-success">99.6% <i className="fa fa-level-up"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card d-flex flex-row flex-wrap">
                            <div className="card-body border-bottom">
                                <div className="flex-fill text-truncate">
                                    <span className="text-muted small text-uppercase">Workers</span>
                                    <span className="h6 mt-3 mb-1 fw-bold d-block">Active</span>
                                    <div className="d-flex justify-content-between">
                                        <div className="price-block">
                                            <span className="fs-6 fw-bold color-price-up">11</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="flex-fill text-truncate">
                                    <span className="text-muted small text-uppercase">Workers</span>
                                    <span className="h6 mt-3 mb-1 fw-bold d-block">Inactive</span>
                                    <div className="d-flex justify-content-between">
                                        <div className="price-block">
                                            <span className="fs-6 fw-bold color-price-down">04</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                                <h6 className="mb-0 fw-bold ">Earnings</h6>
                            </div>
                            <div className="card-body">
                                <div className="row g-3">
                                    <div className="col">
                                        <div className="card">
                                            <div className="card-body d-flex align-items-center">
                                                <div className="flex-fill ms-3 text-truncate">
                                                    <span className="text-muted small text-uppercase">Today Estimated Income</span>
                                                    <div className="d-flex flex-column">
                                                        <div className="price-block">
                                                            <span className="fs-6 fw-bold color-price-up">0.00026 BTC</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="card">
                                            <div className="card-body d-flex align-items-center">
                                                <div className="flex-fill ms-3 text-truncate">
                                                    <span className="text-muted small text-uppercase">Yesterday's Income</span>
                                                    <div className="d-flex flex-column">
                                                        <div className="price-block">
                                                            <span className="fs-6 fw-bold color-price-up">0.00028 BTC</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row g-3">
                    <div className="card mb-3">
                        <div className="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
                            <h6 className="m-0 fw-bold">Chart</h6>
                        </div>
                        <div className="card-body">
                            <div id="mining-stacked-area">
                                <Chart options={state.options} series={state.series} type="area" height={300} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Statistics;
